import React from 'react';
import { FormattedMessage } from 'react-intl';
import ERidesCard from '../ERidesCard/ERidesCard';
import RidesOne from '../../assets/images/RidesOne.jpg';
import RidesTwo from '../../assets/images/RidesTwo.jpg';
import RidesThree from '../../assets/images/RidesThree.jpg';
import './ERidesRebateCards.scss';

const ERidesRebateCards = () => {
  const cardInfo = [
    {
      id: 'eRides.rebates.oneCard',
      price: '$600*',
      vehicle: false,
      title: (
        <FormattedMessage
          id="eRides.rebates.oneTitle"
          defaultMessage="For Individual Customers"
          description="ERides Card One Title"
        />
      ),
      image: RidesOne,
      link: 'https://austinenergy.com/green-power/plug-in-austin/more-ways-to-go-electric/e-ride-rebate',
    },
    {
      id: 'eRides.rebates.twoCard',
      price: '$1,300*',
      vehicle: false,
      title: (
        <FormattedMessage
          id="eRides.rebates.twoTitle"
          defaultMessage="For participants in the {link}"
          description="ERides Card Two Title"
          values={{
            link: (
              <a
                href="https://coautilities.com/wps/wcm/connect/occ/coa/util/support/customer-assistance/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="eRides.rebates.two.title.link"
                  defaultMessage="Customer Assistance Program (CAP)"
                />
              </a>
            ),
          }}
        />
      ),
      image: RidesTwo,
      link: 'https://austinenergy.com/green-power/plug-in-austin/more-ways-to-go-electric/e-ride-rebate',
    },
    {
      id: 'eRides.rebates.threeCard',
      price: '$800',
      vehicle: true,
      title: (
        <FormattedMessage
          id="eRides.rebates.threeTitle"
          defaultMessage="For Fleet customers purchasing 5-25 E-Rides"
          description="ERides Card One Title"
        />
      ),
      image: RidesThree,
      link: 'https://austinenergy.com/green-power/plug-in-austin/more-ways-to-go-electric/e-ride-rebate',
    },
  ];

  const cards = cardInfo.map((card, i) => {
    return (
      <div className={`${'evc-card EVCard'}`} key={i}>
        <ERidesCard
          id={card.id}
          vehicle={card.vehicle}
          price={card.price}
          title={card.title}
          image={card.image}
          link={card.link}
        />
      </div>
    );
  });

  const renderCards = (
    <>
      <div
        className="row d-lg-flex d-xl-flex"
        style={{ justifyContent: 'center' }}
      >
        <div className="col-md-12">
          <div className="render-cards-container full-width">{cards}</div>
        </div>
      </div>
    </>
  );
  return (
    <section className="container" id="ERidesRebateCards">
      <div className="row">
        <div className="col-md-12">
          <div className="banner-center">
            <h2 className="eRides-title">
              <FormattedMessage
                id="eRides.rebate.title"
                defaultMessage="How Much Can You Save?"
                description="ERides Cards Title"
              />
            </h2>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-sm-12 eRides-cards">{renderCards}</div>
      </div>
      <div className="row banner-bottom">
        <p>
          <FormattedMessage
            id="eRides.rebate.description"
            defaultMessage="*All purchases must be made through an {link} to
          qualify."
            description="ERides Rebate Description"
            values={{
              link: (
                <a
                  href="https://austinenergy.com/green-power/plug-in-austin/more-ways-to-go-electric/e-ride-rebate#dealerships"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="eRides.rebate.description.link"
                    defaultMessage="eligible local dealer"
                  />
                </a>
              ),
            }}
          />
        </p>
        <div className="eRides-button">
          <a
            href={`https://austinenergy.com/green-power/plug-in-austin/more-ways-to-go-electric/e-ride-rebate`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-ae"
          >
            <FormattedMessage
              id="eRides.rebate.button"
              defaultMessage="See rebate offerings and apply now"
              description="ERides Cards button"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ERidesRebateCards;
